module.exports = __webpack_public_path__ + "assets/img/thumb-Trade-Glass-Depot-Website.f666bd7f.webp";